import React from "react";
import cn from "../../lib/cn";
import H4 from "../../shared/typography/H4";

const CostDetails = ({
    projectEnable,
    type = "purchase",
    cost,
    savingsTillDate,
    billWithoutSolar,
    monthlySavings,
    savingPercentage,
}) => {
    return (
        <>
            {type === "purchase" ? (
                <>
                    <div className="flex items-center gap-1">
                        <div className="w-2 h-2 bg-blue-light rounded-0.7 mr-1"></div>
                        <H4 className="font-medium text-white md:text-primary md:text-base xl:text-base">
                            Solar Plant Cost
                        </H4>
                        <H4 className="text-white md:text-primary ml-auto md:text-nowrap md:text-lg xl:text-lg">
                            {projectEnable ? cost : "XXXXX"}
                        </H4>
                    </div>

                    <div className="flex items-center gap-1">
                        <div className="w-2 h-2 bg-blue-300 rounded-0.7 mr-1"></div>
                        <H4 className="font-medium text-white md:text-primary md:text-base xl:text-base">
                            Savings Till Date
                        </H4>
                        <H4 className="text-white md:text-primary ml-auto md:text-lg md:text-nowrap xl:text-lg">
                            {projectEnable ? savingsTillDate : "XXXX"}
                        </H4>
                    </div>

                    <div className="w-full h-[10px] bg-gray-130 rounded-3xl relative mt-2">
                        <div
                            className={cn("h-full rounded-3xl bg-blue-light", {
                                "bg-secondary": !projectEnable,
                            })}
                            style={{
                                width: `${80}%`,
                            }}
                        ></div>
                    </div>

                    <div className="w-full h-[10px] bg-gray-130 rounded-3xl relative">
                        <div
                            className={cn("h-full rounded-3xl bg-blue-300", {
                                "bg-secondary": !projectEnable,
                            })}
                            style={{
                                width: `${50}%`,
                            }}
                        ></div>
                    </div>
                </>
            ) : (
                <>
                    <div className="flex items-center gap-1">
                        <div className="w-2 h-2 bg-blue-light rounded-0.7 mr-1"></div>
                        <H4 className="font-medium text-white md:text-primary md:text-base xl:text-base">
                            Bill Without Solar
                        </H4>
                        <H4 className="text-white md:text-primary ml-auto md:text-nowrap md:text-lg xl:text-lg">
                            {projectEnable ? billWithoutSolar : "XXXXX"}
                        </H4>
                    </div>

                    <div className="flex items-center gap-1">
                        <div className="w-2 h-2 bg-blue-300 rounded-0.7 mr-1"></div>
                        <H4 className="font-medium text-white md:text-primary md:text-base xl:text-base">
                            Monthly Savings
                        </H4>
                        <H4 className="text-white md:text-primary ml-auto md:text-nowrap md:text-lg xl:text-lg">
                            {projectEnable ? monthlySavings : "XXXX"}
                        </H4>
                    </div>
                    <div className="flex items-center gap-1">
                        <div className="w-2 h-2 bg-gray-100 rounded-0.7 mr-1"></div>
                        <H4 className="font-medium text-white md:text-primary md:text-base xl:text-base">
                            Saving Percentage
                        </H4>
                        <H4 className="text-white md:text-primary ml-auto md:text-nowrap md:text-lg xl:text-lg">
                            {projectEnable
                                ? savingPercentage?.toFixed(2)
                                : "XXXX"}
                            %
                        </H4>
                    </div>
                    <div className="w-full h-[10px] bg-gray-130 rounded-3xl relative mt-2">
                        <div
                            className={cn("h-full rounded-3xl bg-blue-light", {
                                "bg-secondary": !projectEnable,
                            })}
                            style={{
                                width: `${80}%`,
                            }}
                        ></div>
                    </div>

                    <div className="w-full h-[10px] bg-gray-130 rounded-3xl relative">
                        <div
                            className={cn("h-full rounded-3xl bg-blue-300", {
                                "bg-secondary": !projectEnable,
                            })}
                            style={{
                                width: `${50}%`,
                            }}
                        ></div>
                    </div>
                </>
            )}
        </>
    );
};

export default CostDetails;
